/* eslint-disable -- no need */
import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
export type ValidationCodeResponseFragment = {
  __typename?: 'ValidationCodeResponse';
  status: ValidationCodeResponseStatus;
};

export type AffiliateOrderResponseFragment = {
  __typename?: 'AffiliateOrderResponse';
  orderNumber: string;
  orderId: string;
  paymentUrl?: string | null;
};

export type CommissionResponseBaseFragment = {
  __typename?: 'CommissionResponse';
  id?: string | null;
  pv?: number | null;
  amount?: number | null;
  level?: number | null;
  payedOut?: boolean | null;
  orderNumber?: string | null;
  createdAt?: string | null;
  approvedAt?: string | null;
  payedOutAt?: string | null;
  initials?: string | null;
  status?: CommissionStatus | null;
};

export type CommissionResponseExtraFragment = {
  __typename?: 'CommissionResponse';
  id?: string | null;
  pv?: number | null;
  amount?: number | null;
  level?: number | null;
  payedOut?: boolean | null;
  orderNumber?: string | null;
  createdAt?: string | null;
  approvedAt?: string | null;
  payedOutAt?: string | null;
  initials?: string | null;
  status?: CommissionStatus | null;
  order?: {
    __typename?: 'OrderResponse';
    id?: string | null;
    directReferringMemberId?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    member?: {
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null;
    level1Affiliate?: {
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null;
  member?: {
    __typename?: 'Member';
    email?: string | null;
    id?: string | null;
    createdAt?: string | null;
    countryName?: string | null;
    countryCode?: string | null;
    initials?: string | null;
    level?: number | null;
    monthlyRevenue?: number | null;
    userNumber?: number | null;
    totalReferrals?: number | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null;
};

export type CouponWithCampaignDataFragment = {
  __typename?: 'CouponWithCampaignData';
  couponCodeRequested?: string | null;
  couponCodeProcessed?: string | null;
  couponDiscountRequested?: number | null;
  couponDiscountProcessed?: number | null;
  couponConfig?: string | null;
};

export type CouponFragment = {
  __typename?: 'Coupon';
  id?: string | null;
  code?: string | null;
  isExternal?: boolean | null;
  config?: string | null;
  createdAt?: string | null;
  expiresAt?: string | null;
  deletedAt?: string | null;
  user?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type MemberBaseFragment = {
  __typename?: 'Member';
  email?: string | null;
  id?: string | null;
  createdAt?: string | null;
  countryName?: string | null;
  countryCode?: string | null;
  initials?: string | null;
  level?: number | null;
  monthlyRevenue?: number | null;
  userNumber?: number | null;
  totalReferrals?: number | null;
  commissions?: Array<{
    __typename?: 'CommissionResponse';
    id?: string | null;
    pv?: number | null;
    amount?: number | null;
    level?: number | null;
    payedOut?: boolean | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    payedOutAt?: string | null;
    initials?: string | null;
    status?: CommissionStatus | null;
  } | null> | null;
};

export type MemberExtraFragment = {
  __typename?: 'Member';
  email?: string | null;
  id?: string | null;
  createdAt?: string | null;
  countryName?: string | null;
  countryCode?: string | null;
  initials?: string | null;
  level?: number | null;
  monthlyRevenue?: number | null;
  userNumber?: number | null;
  totalReferrals?: number | null;
  team?: Array<{
    __typename?: 'Member';
    email?: string | null;
    id?: string | null;
    createdAt?: string | null;
    countryName?: string | null;
    countryCode?: string | null;
    initials?: string | null;
    level?: number | null;
    monthlyRevenue?: number | null;
    userNumber?: number | null;
    totalReferrals?: number | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null> | null;
  orders?: Array<{
    __typename?: 'OrderResponse';
    id?: string | null;
    directReferringMemberId?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    member?: {
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null;
    level1Affiliate?: {
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null> | null;
  commissions?: Array<{
    __typename?: 'CommissionResponse';
    id?: string | null;
    pv?: number | null;
    amount?: number | null;
    level?: number | null;
    payedOut?: boolean | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    payedOutAt?: string | null;
    initials?: string | null;
    status?: CommissionStatus | null;
  } | null> | null;
};

export type OrderResponseFragment = {
  __typename?: 'OrderResponse';
  id?: string | null;
  directReferringMemberId?: string | null;
  email?: string | null;
  amount?: number | null;
  currency?: string | null;
  refCode?: string | null;
  couponCode?: string | null;
  orderNumber?: string | null;
  createdAt?: string | null;
  member?: {
    __typename?: 'Member';
    email?: string | null;
    id?: string | null;
    createdAt?: string | null;
    countryName?: string | null;
    countryCode?: string | null;
    initials?: string | null;
    level?: number | null;
    monthlyRevenue?: number | null;
    userNumber?: number | null;
    totalReferrals?: number | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null;
  level1Affiliate?: {
    __typename?: 'Member';
    email?: string | null;
    id?: string | null;
    createdAt?: string | null;
    countryName?: string | null;
    countryCode?: string | null;
    initials?: string | null;
    level?: number | null;
    monthlyRevenue?: number | null;
    userNumber?: number | null;
    totalReferrals?: number | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
    } | null> | null;
  } | null;
  commissions?: Array<{
    __typename?: 'CommissionResponse';
    id?: string | null;
    pv?: number | null;
    amount?: number | null;
    level?: number | null;
    payedOut?: boolean | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    payedOutAt?: string | null;
    initials?: string | null;
    status?: CommissionStatus | null;
  } | null> | null;
};

export type OrderFragment = {
  __typename?: 'Order';
  id?: string | null;
  email?: string | null;
  amount?: number | null;
  currency?: string | null;
  refCode?: string | null;
  couponCode?: string | null;
  orderNumber?: string | null;
  createdAt?: string | null;
  user?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type PaymentDetailsFragment = {
  __typename?: 'PaymentDetails';
  gatewayUrl?: string | null;
  gatewayReference?: string | null;
  gatewayStatus?: string | null;
  paymentGateway?: PaymentGateway | null;
};

export type PaymentDtoFragment = {
  __typename?: 'PaymentDTO';
  order?: {
    __typename?: 'Order';
    id?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
  paymentDetails?: {
    __typename?: 'PaymentDetails';
    gatewayUrl?: string | null;
    gatewayReference?: string | null;
    gatewayStatus?: string | null;
    paymentGateway?: PaymentGateway | null;
  } | null;
};

export type PaymentMethodDetailsFragment = {
  __typename?: 'PaymentMethodDetails';
  id?: string | null;
  displayName?: string | null;
  paymentMethod?: WithdrawalPaymentMethod | null;
  targetAddress?: string | null;
  paymentMethodMetadata?: string | null;
  validatedAt?: string | null;
  deletedAt?: string | null;
  createdAt?: string | null;
  user?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type PayoutDetailFragment = {
  __typename?: 'PayoutDetail';
  amount?: number | null;
  paymentMethodDetails?: {
    __typename?: 'PaymentMethodDetails';
    id?: string | null;
    displayName?: string | null;
    paymentMethod?: WithdrawalPaymentMethod | null;
    targetAddress?: string | null;
    paymentMethodMetadata?: string | null;
    validatedAt?: string | null;
    deletedAt?: string | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
};

export type PayoutDtoFragment = {
  __typename?: 'PayoutDTO';
  id?: string | null;
  userId?: string | null;
  commissionIds?: string | null;
  amount?: number | null;
  status?: PayoutStatus | null;
  email?: string | null;
  userNumber?: number | null;
  createdAt?: string | null;
  approvedAt?: string | null;
};

export type PayoutFragment = {
  __typename?: 'Payout';
  id?: string | null;
  commissionIds?: string | null;
  amount?: number | null;
  status?: PayoutStatus | null;
  email?: string | null;
  userNumber?: number | null;
  createdAt?: string | null;
  approvedAt?: string | null;
  user?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type PayoutsOverviewFragment = {
  __typename?: 'PayoutsOverview';
  amount?: number | null;
  affiliatesPaid?: number | null;
  payoutsIdsList?: string | null;
  month?: string | null;
};

export type UserMetricsFragment = {
  __typename?: 'UserMetrics';
  subAffiliatesNumber: number;
  customersNumber?: number | null;
  unpaidCommissionsAmount: number;
  currentMonthRevenue: number;
  allPossibleCommissionsAmount?: number | null;
  couponCodes?: Array<{
    __typename?: 'CouponWithCampaignData';
    couponCodeRequested?: string | null;
    couponCodeProcessed?: string | null;
    couponDiscountRequested?: number | null;
    couponDiscountProcessed?: number | null;
    couponConfig?: string | null;
  } | null> | null;
  activeCampaignsCoupons?: Array<{
    __typename?: 'Coupon';
    id?: string | null;
    code?: string | null;
    isExternal?: boolean | null;
    config?: string | null;
    createdAt?: string | null;
    expiresAt?: string | null;
    deletedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null> | null;
};

export type UserFragment = {
  __typename?: 'User';
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  phoneVerifiedAt?: string | null;
  emailVerifiedAt?: string | null;
  refcode?: string | null;
  accessToken?: string | null;
  ip2LocationData?: string | null;
  countryCode?: string | null;
  countryName?: string | null;
  preferredLocale?: string | null;
  userNumber: number;
  createdAt: string;
  deletedAt?: string | null;
  role?: string | null;
  initials?: string | null;
  maxCommissionLevel?: number | null;
  networkRole?: NetworkRole | null;
};

export type AddPaymentMethodMutationVariables = Exact<{
  paymentMethodInput?: InputMaybe<PaymentMethodInput>;
}>;

export type AddPaymentMethodMutation = {
  __typename?: 'Mutation';
  addPaymentMethod?: {
    __typename?: 'PaymentMethodDetails';
    id?: string | null;
    displayName?: string | null;
    paymentMethod?: WithdrawalPaymentMethod | null;
    targetAddress?: string | null;
    paymentMethodMetadata?: string | null;
    validatedAt?: string | null;
    deletedAt?: string | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
};

export type ApproveCouponMutationVariables = Exact<{
  couponCode?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  couponConfig?: InputMaybe<CouponConfig>;
}>;

export type ApproveCouponMutation = {
  __typename?: 'Mutation';
  approveCoupon?: {
    __typename?: 'Coupon';
    id?: string | null;
    code?: string | null;
    isExternal?: boolean | null;
    config?: string | null;
    createdAt?: string | null;
    expiresAt?: string | null;
    deletedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
};

export type ApprovePayoutMutationVariables = Exact<{
  payoutId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ApprovePayoutMutation = {
  __typename?: 'Mutation';
  approvePayout?: {
    __typename?: 'Payout';
    id?: string | null;
    commissionIds?: string | null;
    amount?: number | null;
    status?: PayoutStatus | null;
    email?: string | null;
    userNumber?: number | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
};

export type CheckValidationCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type CheckValidationCodeMutation = {
  __typename?: 'Mutation';
  checkValidationCode: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type CustomCouponMutationVariables = Exact<{
  userNumber?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  couponConfig?: InputMaybe<CouponConfig>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
}>;

export type CustomCouponMutation = {
  __typename?: 'Mutation';
  customCoupon?: {
    __typename?: 'Coupon';
    id?: string | null;
    code?: string | null;
    isExternal?: boolean | null;
    config?: string | null;
    createdAt?: string | null;
    expiresAt?: string | null;
    deletedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null;
};

export type ForgottenPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type ForgottenPasswordMutation = {
  __typename?: 'Mutation';
  forgottenPassword: {
    __typename?: 'ForgottenPasswordResponse';
    status?: string | null;
  };
};

export type ImpersonateMutationVariables = Exact<{
  userNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ImpersonateMutation = {
  __typename?: 'Mutation';
  impersonate?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type IncreaseMaxCommissionLevelMutationVariables = Exact<{
  userNumber?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
}>;

export type IncreaseMaxCommissionLevelMutation = {
  __typename?: 'Mutation';
  increaseMaxCommissionLevel?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type InviteMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;

export type InviteMutation = {
  __typename?: 'Mutation';
  invite?: string | null;
};

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginUserMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type PlaceAffiliateOrderMutationVariables = Exact<{
  affiliateOrderInput?: InputMaybe<AffiliateOrderInput>;
}>;

export type PlaceAffiliateOrderMutation = {
  __typename?: 'Mutation';
  affiliateOrder: {
    __typename?: 'AffiliateOrderResponse';
    orderNumber: string;
    orderId: string;
    paymentUrl?: string | null;
  };
};

export type PlaceLevelPackageOrderMutationVariables = Exact<{
  orderInput: OrderInput;
}>;

export type PlaceLevelPackageOrderMutation = {
  __typename?: 'Mutation';
  placeLevelPackageOrder: {
    __typename?: 'Order';
    amount?: number | null;
    createdAt?: string | null;
    couponCode?: string | null;
    currency?: string | null;
    email?: string | null;
    id?: string | null;
    orderNumber?: string | null;
    refCode?: string | null;
    paymentId?: string | null;
    user?: {
      __typename?: 'User';
      email: string;
      initials?: string | null;
      userNumber: number;
    } | null;
  };
};

export type RegisterUserMutationVariables = Exact<{
  userInput: RegistrationUserInput;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RegisterUserMutation = {
  __typename?: 'Mutation';
  register: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type CustomCouponCodeMutationVariables = Exact<{
  couponCodeInput?: InputMaybe<CouponCodeInput>;
}>;

export type CustomCouponCodeMutation = {
  __typename?: 'Mutation';
  customCouponCode: {
    __typename?: 'Coupon';
    id?: string | null;
    code?: string | null;
    isExternal?: boolean | null;
    config?: string | null;
    createdAt?: string | null;
    expiresAt?: string | null;
    deletedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  };
};

export type CustomRefCodeMutationVariables = Exact<{
  refcodeObject: RefCodeInput;
}>;

export type CustomRefCodeMutation = {
  __typename?: 'Mutation';
  customRefCode: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type RequestPaymentForOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  paymentMethod: PaymentGateway;
  theme?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestPaymentForOrderMutation = {
  __typename?: 'Mutation';
  requestPaymentForOrder?: {
    __typename?: 'PaymentDTO';
    order?: {
      __typename?: 'Order';
      id?: string | null;
      email?: string | null;
      amount?: number | null;
      currency?: string | null;
      refCode?: string | null;
      couponCode?: string | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        phone?: string | null;
        phoneVerifiedAt?: string | null;
        emailVerifiedAt?: string | null;
        refcode?: string | null;
        accessToken?: string | null;
        ip2LocationData?: string | null;
        countryCode?: string | null;
        countryName?: string | null;
        preferredLocale?: string | null;
        userNumber: number;
        createdAt: string;
        deletedAt?: string | null;
        role?: string | null;
        initials?: string | null;
        maxCommissionLevel?: number | null;
        networkRole?: NetworkRole | null;
      } | null;
    } | null;
    paymentDetails?: {
      __typename?: 'PaymentDetails';
      gatewayUrl?: string | null;
      gatewayReference?: string | null;
      gatewayStatus?: string | null;
      paymentGateway?: PaymentGateway | null;
    } | null;
  } | null;
};

export type RequestPayoutsMutationVariables = Exact<{
  to?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestPayoutsMutation = {
  __typename?: 'Mutation';
  requestPayouts?: Array<{
    __typename?: 'Payout';
    id?: string | null;
    commissionIds?: string | null;
    amount?: number | null;
    status?: PayoutStatus | null;
    email?: string | null;
    userNumber?: number | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null> | null;
};

export type RequestValidationCodeMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RequestValidationCodeMutation = {
  __typename?: 'Mutation';
  requestValidationCode: {
    __typename?: 'ValidationCodeResponse';
    status: ValidationCodeResponseStatus;
  };
};

export type RerunOrderMutationVariables = Exact<{
  apiEventNumber?: InputMaybe<Scalars['Int']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type RerunOrderMutation = {
  __typename?: 'Mutation';
  rerunOrder: {
    __typename?: 'Order';
    id?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: {
    __typename?: 'ForgottenPasswordResponse';
    status?: string | null;
  };
};

export type SocialLoginMutationVariables = Exact<{
  provider: SocialLoginProvider;
  authorization: Scalars['String']['input'];
  refCode?: InputMaybe<Scalars['String']['input']>;
  networkRole?: InputMaybe<NetworkRole>;
}>;

export type SocialLoginMutation = {
  __typename?: 'Mutation';
  socialLogin?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type UpdateEmailMutation = {
  __typename?: 'Mutation';
  updateEmail: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type UpdateUserNetworkRoleMutationVariables = Exact<{
  userNumber?: InputMaybe<Scalars['Int']['input']>;
  networkRole?: InputMaybe<NetworkRole>;
  maxCommissionLevel?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpdateUserNetworkRoleMutation = {
  __typename?: 'Mutation';
  updateUserNetworkRole?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type GetCommissionWalletQueryVariables = Exact<{ [key: string]: never }>;

export type GetCommissionWalletQuery = {
  __typename?: 'Query';
  commissionWallet?: number | null;
};

export type GetCommissionsMetricsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCommissionsMetricsQuery = {
  __typename?: 'Query';
  commissionsMetrics?: {
    __typename?: 'CommissionsMetrics';
    totalCommissionsAmountThisMonth?: number | null;
    totalCommissionsAmount?: number | null;
  } | null;
};

export type GetCommissionsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  payedOut?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCommissionsQuery = {
  __typename?: 'Query';
  commissions?: {
    __typename?: 'CommissionResponsePage';
    totalPageCount?: number | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
      order?: {
        __typename?: 'OrderResponse';
        id?: string | null;
        directReferringMemberId?: string | null;
        email?: string | null;
        amount?: number | null;
        currency?: string | null;
        refCode?: string | null;
        couponCode?: string | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        member?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        level1Affiliate?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null;
      member?: {
        __typename?: 'Member';
        email?: string | null;
        id?: string | null;
        createdAt?: string | null;
        countryName?: string | null;
        countryCode?: string | null;
        initials?: string | null;
        level?: number | null;
        monthlyRevenue?: number | null;
        userNumber?: number | null;
        totalReferrals?: number | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetForgottenPasswordTokenQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetForgottenPasswordTokenQuery = {
  __typename?: 'Query';
  forgottenPassword: {
    __typename?: 'ForgottenPasswordResponse';
    status?: string | null;
  };
};

export type GetGlobalPayoutsHistoryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetGlobalPayoutsHistoryQuery = {
  __typename?: 'Query';
  globalPayoutsHistory?: Array<{
    __typename?: 'PayoutsOverview';
    amount?: number | null;
    affiliatesPaid?: number | null;
    payoutsIdsList?: string | null;
    month?: string | null;
  } | null> | null;
};

export type GetOrderStatusQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;

export type GetOrderStatusQuery = {
  __typename?: 'Query';
  orderStatus: {
    __typename?: 'Order';
    id?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    paymentId?: string | null;
    pvAmount?: number | null;
    status?: OrderStatus | null;
    commissionLevel?: number | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  };
};

export type GetNextPayoutDetailQueryVariables = Exact<{
  payoutId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetNextPayoutDetailQuery = {
  __typename?: 'Query';
  nextPayoutDetail?: {
    __typename?: 'PayoutDetail';
    amount?: number | null;
    paymentMethodDetails?: {
      __typename?: 'PaymentMethodDetails';
      id?: string | null;
      displayName?: string | null;
      paymentMethod?: WithdrawalPaymentMethod | null;
      targetAddress?: string | null;
      paymentMethodMetadata?: string | null;
      validatedAt?: string | null;
      deletedAt?: string | null;
      createdAt?: string | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        phone?: string | null;
        phoneVerifiedAt?: string | null;
        emailVerifiedAt?: string | null;
        refcode?: string | null;
        accessToken?: string | null;
        ip2LocationData?: string | null;
        countryCode?: string | null;
        countryName?: string | null;
        preferredLocale?: string | null;
        userNumber: number;
        createdAt: string;
        deletedAt?: string | null;
        role?: string | null;
        initials?: string | null;
        maxCommissionLevel?: number | null;
        networkRole?: NetworkRole | null;
      } | null;
    } | null;
  } | null;
};

export type GetNextPayoutsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type GetNextPayoutsQuery = {
  __typename?: 'Query';
  nextPayouts?: {
    __typename?: 'PayoutResponsePage';
    totalPageCount?: number | null;
    payouts?: Array<{
      __typename?: 'PayoutDTO';
      id?: string | null;
      userId?: string | null;
      commissionIds?: string | null;
      amount?: number | null;
      status?: PayoutStatus | null;
      email?: string | null;
      userNumber?: number | null;
      createdAt?: string | null;
      approvedAt?: string | null;
    } | null> | null;
  } | null;
};

export type GetOrderDetailsQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOrderDetailsQuery = {
  __typename?: 'Query';
  orderDetails?: {
    __typename?: 'OrderResponse';
    id?: string | null;
    email?: string | null;
    amount?: number | null;
    currency?: string | null;
    refCode?: string | null;
    couponCode?: string | null;
    orderNumber?: string | null;
    createdAt?: string | null;
    member?: {
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      team?: Array<{
        __typename?: 'Member';
        email?: string | null;
        id?: string | null;
        createdAt?: string | null;
        countryName?: string | null;
        countryCode?: string | null;
        initials?: string | null;
        level?: number | null;
        monthlyRevenue?: number | null;
        userNumber?: number | null;
        totalReferrals?: number | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null> | null;
      orders?: Array<{
        __typename?: 'OrderResponse';
        id?: string | null;
        directReferringMemberId?: string | null;
        email?: string | null;
        amount?: number | null;
        currency?: string | null;
        refCode?: string | null;
        couponCode?: string | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        member?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        level1Affiliate?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null> | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null;
    commissions?: Array<{
      __typename?: 'CommissionResponse';
      id?: string | null;
      pv?: number | null;
      amount?: number | null;
      level?: number | null;
      payedOut?: boolean | null;
      orderNumber?: string | null;
      createdAt?: string | null;
      approvedAt?: string | null;
      payedOutAt?: string | null;
      initials?: string | null;
      status?: CommissionStatus | null;
      order?: {
        __typename?: 'OrderResponse';
        id?: string | null;
        directReferringMemberId?: string | null;
        email?: string | null;
        amount?: number | null;
        currency?: string | null;
        refCode?: string | null;
        couponCode?: string | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        member?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        level1Affiliate?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null;
      member?: {
        __typename?: 'Member';
        email?: string | null;
        id?: string | null;
        createdAt?: string | null;
        countryName?: string | null;
        countryCode?: string | null;
        initials?: string | null;
        level?: number | null;
        monthlyRevenue?: number | null;
        userNumber?: number | null;
        totalReferrals?: number | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaymentMethodsQuery = {
  __typename?: 'Query';
  paymentMethods?: Array<{
    __typename?: 'PaymentMethodDetails';
    id?: string | null;
    displayName?: string | null;
    paymentMethod?: WithdrawalPaymentMethod | null;
    targetAddress?: string | null;
    paymentMethodMetadata?: string | null;
    validatedAt?: string | null;
    deletedAt?: string | null;
    createdAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null> | null;
};

export type GetPayoutsHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetPayoutsHistoryQuery = {
  __typename?: 'Query';
  payoutsHistory?: Array<{
    __typename?: 'Payout';
    id?: string | null;
    commissionIds?: string | null;
    amount?: number | null;
    status?: PayoutStatus | null;
    email?: string | null;
    userNumber?: number | null;
    createdAt?: string | null;
    approvedAt?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone?: string | null;
      phoneVerifiedAt?: string | null;
      emailVerifiedAt?: string | null;
      refcode?: string | null;
      accessToken?: string | null;
      ip2LocationData?: string | null;
      countryCode?: string | null;
      countryName?: string | null;
      preferredLocale?: string | null;
      userNumber: number;
      createdAt: string;
      deletedAt?: string | null;
      role?: string | null;
      initials?: string | null;
      maxCommissionLevel?: number | null;
      networkRole?: NetworkRole | null;
    } | null;
  } | null> | null;
};

export type GetSubaffiliatesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSubaffiliatesQuery = {
  __typename?: 'Query';
  subAffiliates?: {
    __typename?: 'ReferralTeam';
    members?: Array<{
      __typename?: 'Member';
      email?: string | null;
      id?: string | null;
      createdAt?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      initials?: string | null;
      level?: number | null;
      monthlyRevenue?: number | null;
      userNumber?: number | null;
      totalReferrals?: number | null;
      team?: Array<{
        __typename?: 'Member';
        email?: string | null;
        id?: string | null;
        createdAt?: string | null;
        countryName?: string | null;
        countryCode?: string | null;
        initials?: string | null;
        level?: number | null;
        monthlyRevenue?: number | null;
        userNumber?: number | null;
        totalReferrals?: number | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null> | null;
      orders?: Array<{
        __typename?: 'OrderResponse';
        id?: string | null;
        directReferringMemberId?: string | null;
        email?: string | null;
        amount?: number | null;
        currency?: string | null;
        refCode?: string | null;
        couponCode?: string | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        member?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        level1Affiliate?: {
          __typename?: 'Member';
          email?: string | null;
          id?: string | null;
          createdAt?: string | null;
          countryName?: string | null;
          countryCode?: string | null;
          initials?: string | null;
          level?: number | null;
          monthlyRevenue?: number | null;
          userNumber?: number | null;
          totalReferrals?: number | null;
          commissions?: Array<{
            __typename?: 'CommissionResponse';
            id?: string | null;
            pv?: number | null;
            amount?: number | null;
            level?: number | null;
            payedOut?: boolean | null;
            orderNumber?: string | null;
            createdAt?: string | null;
            approvedAt?: string | null;
            payedOutAt?: string | null;
            initials?: string | null;
            status?: CommissionStatus | null;
          } | null> | null;
        } | null;
        commissions?: Array<{
          __typename?: 'CommissionResponse';
          id?: string | null;
          pv?: number | null;
          amount?: number | null;
          level?: number | null;
          payedOut?: boolean | null;
          orderNumber?: string | null;
          createdAt?: string | null;
          approvedAt?: string | null;
          payedOutAt?: string | null;
          initials?: string | null;
          status?: CommissionStatus | null;
        } | null> | null;
      } | null> | null;
      commissions?: Array<{
        __typename?: 'CommissionResponse';
        id?: string | null;
        pv?: number | null;
        amount?: number | null;
        level?: number | null;
        payedOut?: boolean | null;
        orderNumber?: string | null;
        createdAt?: string | null;
        approvedAt?: string | null;
        payedOutAt?: string | null;
        initials?: string | null;
        status?: CommissionStatus | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetUserByEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserByEmailQuery = {
  __typename?: 'Query';
  userByEmail?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type GetUserMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserMetricsQuery = {
  __typename?: 'Query';
  userMetrics: {
    __typename?: 'UserMetrics';
    subAffiliatesNumber: number;
    customersNumber?: number | null;
    unpaidCommissionsAmount: number;
    currentMonthRevenue: number;
    allPossibleCommissionsAmount?: number | null;
    couponCodes?: Array<{
      __typename?: 'CouponWithCampaignData';
      couponCodeRequested?: string | null;
      couponCodeProcessed?: string | null;
      couponDiscountRequested?: number | null;
      couponDiscountProcessed?: number | null;
      couponConfig?: string | null;
    } | null> | null;
    activeCampaignsCoupons?: Array<{
      __typename?: 'Coupon';
      id?: string | null;
      code?: string | null;
      isExternal?: boolean | null;
      config?: string | null;
      createdAt?: string | null;
      expiresAt?: string | null;
      deletedAt?: string | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        phone?: string | null;
        phoneVerifiedAt?: string | null;
        emailVerifiedAt?: string | null;
        refcode?: string | null;
        accessToken?: string | null;
        ip2LocationData?: string | null;
        countryCode?: string | null;
        countryName?: string | null;
        preferredLocale?: string | null;
        userNumber: number;
        createdAt: string;
        deletedAt?: string | null;
        role?: string | null;
        initials?: string | null;
        maxCommissionLevel?: number | null;
        networkRole?: NetworkRole | null;
      } | null;
    } | null> | null;
  };
};

export type GetUserQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  } | null;
};

export type GetViewerQueryVariables = Exact<{ [key: string]: never }>;

export type GetViewerQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    refcode?: string | null;
    accessToken?: string | null;
    ip2LocationData?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    preferredLocale?: string | null;
    userNumber: number;
    createdAt: string;
    deletedAt?: string | null;
    role?: string | null;
    initials?: string | null;
    maxCommissionLevel?: number | null;
    networkRole?: NetworkRole | null;
  };
};

export type RecalculateAffiliateOrderQueryVariables = Exact<{
  accountSize?: InputMaybe<Scalars['Int']['input']>;
  addonTypesOnOrder?: InputMaybe<
    Array<InputMaybe<AddonType>> | InputMaybe<AddonType>
  >;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  stepsType?: InputMaybe<StepsType>;
}>;

export type RecalculateAffiliateOrderQuery = {
  __typename?: 'Query';
  recalculateAffiliateOrder: number;
};

export const ValidationCodeResponseFragmentDoc = gql`
  fragment ValidationCodeResponse on ValidationCodeResponse {
    status
  }
`;
export const AffiliateOrderResponseFragmentDoc = gql`
  fragment AffiliateOrderResponse on AffiliateOrderResponse {
    orderNumber
    orderId
    paymentUrl
  }
`;
export const CommissionResponseBaseFragmentDoc = gql`
  fragment CommissionResponseBase on CommissionResponse {
    id
    pv
    amount
    level
    payedOut
    orderNumber
    createdAt
    approvedAt
    payedOutAt
    initials
    status
  }
`;
export const MemberBaseFragmentDoc = gql`
  fragment MemberBase on Member {
    email
    id
    createdAt
    countryName
    countryCode
    initials
    level
    monthlyRevenue
    userNumber
    totalReferrals
    commissions {
      ...CommissionResponseBase
    }
  }
  ${CommissionResponseBaseFragmentDoc}
`;
export const OrderResponseFragmentDoc = gql`
  fragment OrderResponse on OrderResponse {
    id
    member {
      ...MemberBase
    }
    level1Affiliate {
      ...MemberBase
    }
    commissions {
      ...CommissionResponseBase
    }
    directReferringMemberId
    email
    amount
    currency
    refCode
    couponCode
    orderNumber
    createdAt
  }
  ${MemberBaseFragmentDoc}
  ${CommissionResponseBaseFragmentDoc}
`;
export const CommissionResponseExtraFragmentDoc = gql`
  fragment CommissionResponseExtra on CommissionResponse {
    ...CommissionResponseBase
    order {
      ...OrderResponse
    }
    member {
      ...MemberBase
    }
  }
  ${CommissionResponseBaseFragmentDoc}
  ${OrderResponseFragmentDoc}
  ${MemberBaseFragmentDoc}
`;
export const MemberExtraFragmentDoc = gql`
  fragment MemberExtra on Member {
    ...MemberBase
    team {
      ...MemberBase
    }
    orders {
      ...OrderResponse
    }
  }
  ${MemberBaseFragmentDoc}
  ${OrderResponseFragmentDoc}
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    id
    firstName
    lastName
    email
    phone
    phoneVerifiedAt
    emailVerifiedAt
    refcode
    accessToken
    ip2LocationData
    countryCode
    countryName
    preferredLocale
    userNumber
    createdAt
    deletedAt
    role
    initials
    maxCommissionLevel
    networkRole
  }
`;
export const OrderFragmentDoc = gql`
  fragment Order on Order {
    id
    user {
      ...User
    }
    email
    amount
    currency
    refCode
    couponCode
    orderNumber
    createdAt
  }
  ${UserFragmentDoc}
`;
export const PaymentDetailsFragmentDoc = gql`
  fragment PaymentDetails on PaymentDetails {
    gatewayUrl
    gatewayReference
    gatewayStatus
    paymentGateway
  }
`;
export const PaymentDtoFragmentDoc = gql`
  fragment PaymentDTO on PaymentDTO {
    order {
      ...Order
    }
    paymentDetails {
      ...PaymentDetails
    }
  }
  ${OrderFragmentDoc}
  ${PaymentDetailsFragmentDoc}
`;
export const PaymentMethodDetailsFragmentDoc = gql`
  fragment PaymentMethodDetails on PaymentMethodDetails {
    id
    user {
      ...User
    }
    displayName
    paymentMethod
    targetAddress
    paymentMethodMetadata
    validatedAt
    deletedAt
    createdAt
  }
  ${UserFragmentDoc}
`;
export const PayoutDetailFragmentDoc = gql`
  fragment PayoutDetail on PayoutDetail {
    paymentMethodDetails {
      ...PaymentMethodDetails
    }
    amount
  }
  ${PaymentMethodDetailsFragmentDoc}
`;
export const PayoutDtoFragmentDoc = gql`
  fragment PayoutDTO on PayoutDTO {
    id
    userId
    commissionIds
    amount
    status
    email
    userNumber
    createdAt
    approvedAt
  }
`;
export const PayoutFragmentDoc = gql`
  fragment Payout on Payout {
    id
    user {
      ...User
    }
    commissionIds
    amount
    status
    email
    userNumber
    createdAt
    approvedAt
  }
  ${UserFragmentDoc}
`;
export const PayoutsOverviewFragmentDoc = gql`
  fragment PayoutsOverview on PayoutsOverview {
    amount
    affiliatesPaid
    payoutsIdsList
    month
  }
`;
export const CouponWithCampaignDataFragmentDoc = gql`
  fragment CouponWithCampaignData on CouponWithCampaignData {
    couponCodeRequested
    couponCodeProcessed
    couponDiscountRequested
    couponDiscountProcessed
    couponConfig
  }
`;
export const CouponFragmentDoc = gql`
  fragment Coupon on Coupon {
    id
    user {
      ...User
    }
    code
    isExternal
    config
    createdAt
    expiresAt
    deletedAt
  }
  ${UserFragmentDoc}
`;
export const UserMetricsFragmentDoc = gql`
  fragment UserMetrics on UserMetrics {
    subAffiliatesNumber
    customersNumber
    unpaidCommissionsAmount
    currentMonthRevenue
    allPossibleCommissionsAmount
    couponCodes {
      ...CouponWithCampaignData
    }
    activeCampaignsCoupons {
      ...Coupon
    }
  }
  ${CouponWithCampaignDataFragmentDoc}
  ${CouponFragmentDoc}
`;
export const AddPaymentMethodDocument = gql`
  mutation AddPaymentMethod($paymentMethodInput: PaymentMethodInput) {
    addPaymentMethod(paymentMethodInput: $paymentMethodInput) {
      ...PaymentMethodDetails
    }
  }
  ${PaymentMethodDetailsFragmentDoc}
`;
export type AddPaymentMethodMutationFn = Apollo.MutationFunction<
  AddPaymentMethodMutation,
  AddPaymentMethodMutationVariables
>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      paymentMethodInput: // value for 'paymentMethodInput'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPaymentMethodMutation,
    AddPaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddPaymentMethodMutation,
    AddPaymentMethodMutationVariables
  >(AddPaymentMethodDocument, options);
}
export type AddPaymentMethodMutationHookResult = ReturnType<
  typeof useAddPaymentMethodMutation
>;
export type AddPaymentMethodMutationResult =
  Apollo.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  AddPaymentMethodMutation,
  AddPaymentMethodMutationVariables
>;
export const ApproveCouponDocument = gql`
  mutation ApproveCoupon(
    $couponCode: String
    $expirationDate: String
    $startDate: String
    $couponConfig: CouponConfig
  ) {
    approveCoupon(
      couponCode: $couponCode
      expirationDate: $expirationDate
      startDate: $startDate
      couponConfig: $couponConfig
    ) {
      ...Coupon
    }
  }
  ${CouponFragmentDoc}
`;
export type ApproveCouponMutationFn = Apollo.MutationFunction<
  ApproveCouponMutation,
  ApproveCouponMutationVariables
>;

/**
 * __useApproveCouponMutation__
 *
 * To run a mutation, you first call `useApproveCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCouponMutation, { data, loading, error }] = useApproveCouponMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *      expirationDate: // value for 'expirationDate'
 *      startDate: // value for 'startDate'
 *      couponConfig: // value for 'couponConfig'
 *   },
 * });
 */
export function useApproveCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveCouponMutation,
    ApproveCouponMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveCouponMutation,
    ApproveCouponMutationVariables
  >(ApproveCouponDocument, options);
}
export type ApproveCouponMutationHookResult = ReturnType<
  typeof useApproveCouponMutation
>;
export type ApproveCouponMutationResult =
  Apollo.MutationResult<ApproveCouponMutation>;
export type ApproveCouponMutationOptions = Apollo.BaseMutationOptions<
  ApproveCouponMutation,
  ApproveCouponMutationVariables
>;
export const ApprovePayoutDocument = gql`
  mutation ApprovePayout($payoutId: String) {
    approvePayout(payoutId: $payoutId) {
      ...Payout
    }
  }
  ${PayoutFragmentDoc}
`;
export type ApprovePayoutMutationFn = Apollo.MutationFunction<
  ApprovePayoutMutation,
  ApprovePayoutMutationVariables
>;

/**
 * __useApprovePayoutMutation__
 *
 * To run a mutation, you first call `useApprovePayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePayoutMutation, { data, loading, error }] = useApprovePayoutMutation({
 *   variables: {
 *      payoutId: // value for 'payoutId'
 *   },
 * });
 */
export function useApprovePayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovePayoutMutation,
    ApprovePayoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApprovePayoutMutation,
    ApprovePayoutMutationVariables
  >(ApprovePayoutDocument, options);
}
export type ApprovePayoutMutationHookResult = ReturnType<
  typeof useApprovePayoutMutation
>;
export type ApprovePayoutMutationResult =
  Apollo.MutationResult<ApprovePayoutMutation>;
export type ApprovePayoutMutationOptions = Apollo.BaseMutationOptions<
  ApprovePayoutMutation,
  ApprovePayoutMutationVariables
>;
export const CheckValidationCodeDocument = gql`
  mutation CheckValidationCode($code: String!) {
    checkValidationCode(code: $code) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type CheckValidationCodeMutationFn = Apollo.MutationFunction<
  CheckValidationCodeMutation,
  CheckValidationCodeMutationVariables
>;

/**
 * __useCheckValidationCodeMutation__
 *
 * To run a mutation, you first call `useCheckValidationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckValidationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkValidationCodeMutation, { data, loading, error }] = useCheckValidationCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckValidationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckValidationCodeMutation,
    CheckValidationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckValidationCodeMutation,
    CheckValidationCodeMutationVariables
  >(CheckValidationCodeDocument, options);
}
export type CheckValidationCodeMutationHookResult = ReturnType<
  typeof useCheckValidationCodeMutation
>;
export type CheckValidationCodeMutationResult =
  Apollo.MutationResult<CheckValidationCodeMutation>;
export type CheckValidationCodeMutationOptions = Apollo.BaseMutationOptions<
  CheckValidationCodeMutation,
  CheckValidationCodeMutationVariables
>;
export const CustomCouponDocument = gql`
  mutation CustomCoupon(
    $userNumber: Int
    $couponCode: String
    $couponConfig: CouponConfig
    $expirationDate: String
  ) {
    customCoupon(
      userNumber: $userNumber
      couponCode: $couponCode
      couponConfig: $couponConfig
      expirationDate: $expirationDate
    ) {
      ...Coupon
    }
  }
  ${CouponFragmentDoc}
`;
export type CustomCouponMutationFn = Apollo.MutationFunction<
  CustomCouponMutation,
  CustomCouponMutationVariables
>;

/**
 * __useCustomCouponMutation__
 *
 * To run a mutation, you first call `useCustomCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCouponMutation, { data, loading, error }] = useCustomCouponMutation({
 *   variables: {
 *      userNumber: // value for 'userNumber'
 *      couponCode: // value for 'couponCode'
 *      couponConfig: // value for 'couponConfig'
 *      expirationDate: // value for 'expirationDate'
 *   },
 * });
 */
export function useCustomCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomCouponMutation,
    CustomCouponMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomCouponMutation,
    CustomCouponMutationVariables
  >(CustomCouponDocument, options);
}
export type CustomCouponMutationHookResult = ReturnType<
  typeof useCustomCouponMutation
>;
export type CustomCouponMutationResult =
  Apollo.MutationResult<CustomCouponMutation>;
export type CustomCouponMutationOptions = Apollo.BaseMutationOptions<
  CustomCouponMutation,
  CustomCouponMutationVariables
>;
export const ForgottenPasswordDocument = gql`
  mutation ForgottenPassword($email: String!) {
    forgottenPassword(email: $email) {
      status
    }
  }
`;
export type ForgottenPasswordMutationFn = Apollo.MutationFunction<
  ForgottenPasswordMutation,
  ForgottenPasswordMutationVariables
>;

/**
 * __useForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgottenPasswordMutation, { data, loading, error }] = useForgottenPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgottenPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ForgottenPasswordMutation,
    ForgottenPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ForgottenPasswordMutation,
    ForgottenPasswordMutationVariables
  >(ForgottenPasswordDocument, options);
}
export type ForgottenPasswordMutationHookResult = ReturnType<
  typeof useForgottenPasswordMutation
>;
export type ForgottenPasswordMutationResult =
  Apollo.MutationResult<ForgottenPasswordMutation>;
export type ForgottenPasswordMutationOptions = Apollo.BaseMutationOptions<
  ForgottenPasswordMutation,
  ForgottenPasswordMutationVariables
>;
export const ImpersonateDocument = gql`
  mutation Impersonate($userNumber: Int) {
    impersonate(userNumber: $userNumber) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type ImpersonateMutationFn = Apollo.MutationFunction<
  ImpersonateMutation,
  ImpersonateMutationVariables
>;

/**
 * __useImpersonateMutation__
 *
 * To run a mutation, you first call `useImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateMutation, { data, loading, error }] = useImpersonateMutation({
 *   variables: {
 *      userNumber: // value for 'userNumber'
 *   },
 * });
 */
export function useImpersonateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImpersonateMutation,
    ImpersonateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImpersonateMutation, ImpersonateMutationVariables>(
    ImpersonateDocument,
    options,
  );
}
export type ImpersonateMutationHookResult = ReturnType<
  typeof useImpersonateMutation
>;
export type ImpersonateMutationResult =
  Apollo.MutationResult<ImpersonateMutation>;
export type ImpersonateMutationOptions = Apollo.BaseMutationOptions<
  ImpersonateMutation,
  ImpersonateMutationVariables
>;
export const IncreaseMaxCommissionLevelDocument = gql`
  mutation IncreaseMaxCommissionLevel($userNumber: Int, $level: Int) {
    increaseMaxCommissionLevel(userNumber: $userNumber, level: $level) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type IncreaseMaxCommissionLevelMutationFn = Apollo.MutationFunction<
  IncreaseMaxCommissionLevelMutation,
  IncreaseMaxCommissionLevelMutationVariables
>;

/**
 * __useIncreaseMaxCommissionLevelMutation__
 *
 * To run a mutation, you first call `useIncreaseMaxCommissionLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncreaseMaxCommissionLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [increaseMaxCommissionLevelMutation, { data, loading, error }] = useIncreaseMaxCommissionLevelMutation({
 *   variables: {
 *      userNumber: // value for 'userNumber'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useIncreaseMaxCommissionLevelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IncreaseMaxCommissionLevelMutation,
    IncreaseMaxCommissionLevelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IncreaseMaxCommissionLevelMutation,
    IncreaseMaxCommissionLevelMutationVariables
  >(IncreaseMaxCommissionLevelDocument, options);
}
export type IncreaseMaxCommissionLevelMutationHookResult = ReturnType<
  typeof useIncreaseMaxCommissionLevelMutation
>;
export type IncreaseMaxCommissionLevelMutationResult =
  Apollo.MutationResult<IncreaseMaxCommissionLevelMutation>;
export type IncreaseMaxCommissionLevelMutationOptions =
  Apollo.BaseMutationOptions<
    IncreaseMaxCommissionLevelMutation,
    IncreaseMaxCommissionLevelMutationVariables
  >;
export const InviteDocument = gql`
  mutation Invite($email: String) {
    invite(email: $email)
  }
`;
export type InviteMutationFn = Apollo.MutationFunction<
  InviteMutation,
  InviteMutationVariables
>;

/**
 * __useInviteMutation__
 *
 * To run a mutation, you first call `useInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMutation, { data, loading, error }] = useInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteMutation,
    InviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InviteMutation, InviteMutationVariables>(
    InviteDocument,
    options,
  );
}
export type InviteMutationHookResult = ReturnType<typeof useInviteMutation>;
export type InviteMutationResult = Apollo.MutationResult<InviteMutation>;
export type InviteMutationOptions = Apollo.BaseMutationOptions<
  InviteMutation,
  InviteMutationVariables
>;
export const LoginUserDocument = gql`
  mutation LoginUser($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type LoginUserMutationFn = Apollo.MutationFunction<
  LoginUserMutation,
  LoginUserMutationVariables
>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginUserMutation,
    LoginUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(
    LoginUserDocument,
    options,
  );
}
export type LoginUserMutationHookResult = ReturnType<
  typeof useLoginUserMutation
>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<
  LoginUserMutation,
  LoginUserMutationVariables
>;
export const PlaceAffiliateOrderDocument = gql`
  mutation PlaceAffiliateOrder($affiliateOrderInput: AffiliateOrderInput) {
    affiliateOrder(affiliateOrderInput: $affiliateOrderInput) {
      ...AffiliateOrderResponse
    }
  }
  ${AffiliateOrderResponseFragmentDoc}
`;
export type PlaceAffiliateOrderMutationFn = Apollo.MutationFunction<
  PlaceAffiliateOrderMutation,
  PlaceAffiliateOrderMutationVariables
>;

/**
 * __usePlaceAffiliateOrderMutation__
 *
 * To run a mutation, you first call `usePlaceAffiliateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceAffiliateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeAffiliateOrderMutation, { data, loading, error }] = usePlaceAffiliateOrderMutation({
 *   variables: {
 *      affiliateOrderInput: // value for 'affiliateOrderInput'
 *   },
 * });
 */
export function usePlaceAffiliateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaceAffiliateOrderMutation,
    PlaceAffiliateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlaceAffiliateOrderMutation,
    PlaceAffiliateOrderMutationVariables
  >(PlaceAffiliateOrderDocument, options);
}
export type PlaceAffiliateOrderMutationHookResult = ReturnType<
  typeof usePlaceAffiliateOrderMutation
>;
export type PlaceAffiliateOrderMutationResult =
  Apollo.MutationResult<PlaceAffiliateOrderMutation>;
export type PlaceAffiliateOrderMutationOptions = Apollo.BaseMutationOptions<
  PlaceAffiliateOrderMutation,
  PlaceAffiliateOrderMutationVariables
>;
export const PlaceLevelPackageOrderDocument = gql`
  mutation placeLevelPackageOrder($orderInput: OrderInput!) {
    placeLevelPackageOrder(orderInput: $orderInput) {
      amount
      createdAt
      couponCode
      currency
      email
      id
      orderNumber
      refCode
      user {
        email
        initials
        userNumber
      }
      paymentId
    }
  }
`;
export type PlaceLevelPackageOrderMutationFn = Apollo.MutationFunction<
  PlaceLevelPackageOrderMutation,
  PlaceLevelPackageOrderMutationVariables
>;

/**
 * __usePlaceLevelPackageOrderMutation__
 *
 * To run a mutation, you first call `usePlaceLevelPackageOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceLevelPackageOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeLevelPackageOrderMutation, { data, loading, error }] = usePlaceLevelPackageOrderMutation({
 *   variables: {
 *      orderInput: // value for 'orderInput'
 *   },
 * });
 */
export function usePlaceLevelPackageOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaceLevelPackageOrderMutation,
    PlaceLevelPackageOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlaceLevelPackageOrderMutation,
    PlaceLevelPackageOrderMutationVariables
  >(PlaceLevelPackageOrderDocument, options);
}
export type PlaceLevelPackageOrderMutationHookResult = ReturnType<
  typeof usePlaceLevelPackageOrderMutation
>;
export type PlaceLevelPackageOrderMutationResult =
  Apollo.MutationResult<PlaceLevelPackageOrderMutation>;
export type PlaceLevelPackageOrderMutationOptions = Apollo.BaseMutationOptions<
  PlaceLevelPackageOrderMutation,
  PlaceLevelPackageOrderMutationVariables
>;
export const RegisterUserDocument = gql`
  mutation RegisterUser(
    $userInput: RegistrationUserInput!
    $sendEmail: Boolean = true
  ) {
    register(userInput: $userInput, sendEmail: $sendEmail) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type RegisterUserMutationFn = Apollo.MutationFunction<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useRegisterUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >(RegisterUserDocument, options);
}
export type RegisterUserMutationHookResult = ReturnType<
  typeof useRegisterUserMutation
>;
export type RegisterUserMutationResult =
  Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;
export const CustomCouponCodeDocument = gql`
  mutation CustomCouponCode($couponCodeInput: CouponCodeInput) {
    customCouponCode(couponCodeInput: $couponCodeInput) {
      ...Coupon
    }
  }
  ${CouponFragmentDoc}
`;
export type CustomCouponCodeMutationFn = Apollo.MutationFunction<
  CustomCouponCodeMutation,
  CustomCouponCodeMutationVariables
>;

/**
 * __useCustomCouponCodeMutation__
 *
 * To run a mutation, you first call `useCustomCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCouponCodeMutation, { data, loading, error }] = useCustomCouponCodeMutation({
 *   variables: {
 *      couponCodeInput: // value for 'couponCodeInput'
 *   },
 * });
 */
export function useCustomCouponCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomCouponCodeMutation,
    CustomCouponCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomCouponCodeMutation,
    CustomCouponCodeMutationVariables
  >(CustomCouponCodeDocument, options);
}
export type CustomCouponCodeMutationHookResult = ReturnType<
  typeof useCustomCouponCodeMutation
>;
export type CustomCouponCodeMutationResult =
  Apollo.MutationResult<CustomCouponCodeMutation>;
export type CustomCouponCodeMutationOptions = Apollo.BaseMutationOptions<
  CustomCouponCodeMutation,
  CustomCouponCodeMutationVariables
>;
export const CustomRefCodeDocument = gql`
  mutation CustomRefCode($refcodeObject: RefCodeInput!) {
    customRefCode(refcodeObject: $refcodeObject) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type CustomRefCodeMutationFn = Apollo.MutationFunction<
  CustomRefCodeMutation,
  CustomRefCodeMutationVariables
>;

/**
 * __useCustomRefCodeMutation__
 *
 * To run a mutation, you first call `useCustomRefCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomRefCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customRefCodeMutation, { data, loading, error }] = useCustomRefCodeMutation({
 *   variables: {
 *      refcodeObject: // value for 'refcodeObject'
 *   },
 * });
 */
export function useCustomRefCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomRefCodeMutation,
    CustomRefCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomRefCodeMutation,
    CustomRefCodeMutationVariables
  >(CustomRefCodeDocument, options);
}
export type CustomRefCodeMutationHookResult = ReturnType<
  typeof useCustomRefCodeMutation
>;
export type CustomRefCodeMutationResult =
  Apollo.MutationResult<CustomRefCodeMutation>;
export type CustomRefCodeMutationOptions = Apollo.BaseMutationOptions<
  CustomRefCodeMutation,
  CustomRefCodeMutationVariables
>;
export const RequestPaymentForOrderDocument = gql`
  mutation RequestPaymentForOrder(
    $orderId: String!
    $paymentMethod: PaymentGateway!
    $theme: String
  ) {
    requestPaymentForOrder(
      orderId: $orderId
      paymentMethod: $paymentMethod
      theme: $theme
    ) {
      ...PaymentDTO
    }
  }
  ${PaymentDtoFragmentDoc}
`;
export type RequestPaymentForOrderMutationFn = Apollo.MutationFunction<
  RequestPaymentForOrderMutation,
  RequestPaymentForOrderMutationVariables
>;

/**
 * __useRequestPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useRequestPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPaymentForOrderMutation, { data, loading, error }] = useRequestPaymentForOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      paymentMethod: // value for 'paymentMethod'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useRequestPaymentForOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPaymentForOrderMutation,
    RequestPaymentForOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPaymentForOrderMutation,
    RequestPaymentForOrderMutationVariables
  >(RequestPaymentForOrderDocument, options);
}
export type RequestPaymentForOrderMutationHookResult = ReturnType<
  typeof useRequestPaymentForOrderMutation
>;
export type RequestPaymentForOrderMutationResult =
  Apollo.MutationResult<RequestPaymentForOrderMutation>;
export type RequestPaymentForOrderMutationOptions = Apollo.BaseMutationOptions<
  RequestPaymentForOrderMutation,
  RequestPaymentForOrderMutationVariables
>;
export const RequestPayoutsDocument = gql`
  mutation RequestPayouts($to: String) {
    requestPayouts(to: $to) {
      ...Payout
    }
  }
  ${PayoutFragmentDoc}
`;
export type RequestPayoutsMutationFn = Apollo.MutationFunction<
  RequestPayoutsMutation,
  RequestPayoutsMutationVariables
>;

/**
 * __useRequestPayoutsMutation__
 *
 * To run a mutation, you first call `useRequestPayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPayoutsMutation, { data, loading, error }] = useRequestPayoutsMutation({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useRequestPayoutsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPayoutsMutation,
    RequestPayoutsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPayoutsMutation,
    RequestPayoutsMutationVariables
  >(RequestPayoutsDocument, options);
}
export type RequestPayoutsMutationHookResult = ReturnType<
  typeof useRequestPayoutsMutation
>;
export type RequestPayoutsMutationResult =
  Apollo.MutationResult<RequestPayoutsMutation>;
export type RequestPayoutsMutationOptions = Apollo.BaseMutationOptions<
  RequestPayoutsMutation,
  RequestPayoutsMutationVariables
>;
export const RequestValidationCodeDocument = gql`
  mutation RequestValidationCode {
    requestValidationCode {
      ...ValidationCodeResponse
    }
  }
  ${ValidationCodeResponseFragmentDoc}
`;
export type RequestValidationCodeMutationFn = Apollo.MutationFunction<
  RequestValidationCodeMutation,
  RequestValidationCodeMutationVariables
>;

/**
 * __useRequestValidationCodeMutation__
 *
 * To run a mutation, you first call `useRequestValidationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestValidationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestValidationCodeMutation, { data, loading, error }] = useRequestValidationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestValidationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestValidationCodeMutation,
    RequestValidationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestValidationCodeMutation,
    RequestValidationCodeMutationVariables
  >(RequestValidationCodeDocument, options);
}
export type RequestValidationCodeMutationHookResult = ReturnType<
  typeof useRequestValidationCodeMutation
>;
export type RequestValidationCodeMutationResult =
  Apollo.MutationResult<RequestValidationCodeMutation>;
export type RequestValidationCodeMutationOptions = Apollo.BaseMutationOptions<
  RequestValidationCodeMutation,
  RequestValidationCodeMutationVariables
>;
export const RerunOrderDocument = gql`
  mutation RerunOrder(
    $apiEventNumber: Int
    $refCode: String
    $couponCode: String
  ) {
    rerunOrder(
      apiEventNumber: $apiEventNumber
      refCode: $refCode
      couponCode: $couponCode
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`;
export type RerunOrderMutationFn = Apollo.MutationFunction<
  RerunOrderMutation,
  RerunOrderMutationVariables
>;

/**
 * __useRerunOrderMutation__
 *
 * To run a mutation, you first call `useRerunOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunOrderMutation, { data, loading, error }] = useRerunOrderMutation({
 *   variables: {
 *      apiEventNumber: // value for 'apiEventNumber'
 *      refCode: // value for 'refCode'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useRerunOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RerunOrderMutation,
    RerunOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RerunOrderMutation, RerunOrderMutationVariables>(
    RerunOrderDocument,
    options,
  );
}
export type RerunOrderMutationHookResult = ReturnType<
  typeof useRerunOrderMutation
>;
export type RerunOrderMutationResult =
  Apollo.MutationResult<RerunOrderMutation>;
export type RerunOrderMutationOptions = Apollo.BaseMutationOptions<
  RerunOrderMutation,
  RerunOrderMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($id: String!, $password: String!) {
    resetPassword(id: $id, password: $password) {
      status
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SocialLoginDocument = gql`
  mutation SocialLogin(
    $provider: SocialLoginProvider!
    $authorization: String!
    $refCode: String
    $networkRole: NetworkRole
  ) {
    socialLogin(
      provider: $provider
      authorization: $authorization
      refCode: $refCode
      networkRole: $networkRole
    ) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type SocialLoginMutationFn = Apollo.MutationFunction<
  SocialLoginMutation,
  SocialLoginMutationVariables
>;

/**
 * __useSocialLoginMutation__
 *
 * To run a mutation, you first call `useSocialLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialLoginMutation, { data, loading, error }] = useSocialLoginMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      authorization: // value for 'authorization'
 *      refCode: // value for 'refCode'
 *      networkRole: // value for 'networkRole'
 *   },
 * });
 */
export function useSocialLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SocialLoginMutation,
    SocialLoginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SocialLoginMutation, SocialLoginMutationVariables>(
    SocialLoginDocument,
    options,
  );
}
export type SocialLoginMutationHookResult = ReturnType<
  typeof useSocialLoginMutation
>;
export type SocialLoginMutationResult =
  Apollo.MutationResult<SocialLoginMutation>;
export type SocialLoginMutationOptions = Apollo.BaseMutationOptions<
  SocialLoginMutation,
  SocialLoginMutationVariables
>;
export const UpdateEmailDocument = gql`
  mutation UpdateEmail($email: String!) {
    updateEmail(email: $email) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type UpdateEmailMutationFn = Apollo.MutationFunction<
  UpdateEmailMutation,
  UpdateEmailMutationVariables
>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmailMutation,
    UpdateEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(
    UpdateEmailDocument,
    options,
  );
}
export type UpdateEmailMutationHookResult = ReturnType<
  typeof useUpdateEmailMutation
>;
export type UpdateEmailMutationResult =
  Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmailMutation,
  UpdateEmailMutationVariables
>;
export const UpdateUserNetworkRoleDocument = gql`
  mutation UpdateUserNetworkRole(
    $userNumber: Int
    $networkRole: NetworkRole
    $maxCommissionLevel: Int = 1
  ) {
    updateUserNetworkRole(
      userNumber: $userNumber
      networkRole: $networkRole
      maxCommissionLevel: $maxCommissionLevel
    ) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type UpdateUserNetworkRoleMutationFn = Apollo.MutationFunction<
  UpdateUserNetworkRoleMutation,
  UpdateUserNetworkRoleMutationVariables
>;

/**
 * __useUpdateUserNetworkRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserNetworkRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNetworkRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNetworkRoleMutation, { data, loading, error }] = useUpdateUserNetworkRoleMutation({
 *   variables: {
 *      userNumber: // value for 'userNumber'
 *      networkRole: // value for 'networkRole'
 *      maxCommissionLevel: // value for 'maxCommissionLevel'
 *   },
 * });
 */
export function useUpdateUserNetworkRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNetworkRoleMutation,
    UpdateUserNetworkRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserNetworkRoleMutation,
    UpdateUserNetworkRoleMutationVariables
  >(UpdateUserNetworkRoleDocument, options);
}
export type UpdateUserNetworkRoleMutationHookResult = ReturnType<
  typeof useUpdateUserNetworkRoleMutation
>;
export type UpdateUserNetworkRoleMutationResult =
  Apollo.MutationResult<UpdateUserNetworkRoleMutation>;
export type UpdateUserNetworkRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNetworkRoleMutation,
  UpdateUserNetworkRoleMutationVariables
>;
export const GetCommissionWalletDocument = gql`
  query GetCommissionWallet {
    commissionWallet
  }
`;

/**
 * __useGetCommissionWalletQuery__
 *
 * To run a query within a React component, call `useGetCommissionWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionWalletQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionWalletQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCommissionWalletQuery,
    GetCommissionWalletQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommissionWalletQuery,
    GetCommissionWalletQueryVariables
  >(GetCommissionWalletDocument, options);
}
export function useGetCommissionWalletLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommissionWalletQuery,
    GetCommissionWalletQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommissionWalletQuery,
    GetCommissionWalletQueryVariables
  >(GetCommissionWalletDocument, options);
}
export type GetCommissionWalletQueryHookResult = ReturnType<
  typeof useGetCommissionWalletQuery
>;
export type GetCommissionWalletLazyQueryHookResult = ReturnType<
  typeof useGetCommissionWalletLazyQuery
>;
export type GetCommissionWalletQueryResult = Apollo.QueryResult<
  GetCommissionWalletQuery,
  GetCommissionWalletQueryVariables
>;
export const GetCommissionsMetricsDocument = gql`
  query GetCommissionsMetrics {
    commissionsMetrics {
      totalCommissionsAmountThisMonth
      totalCommissionsAmount
    }
  }
`;

/**
 * __useGetCommissionsMetricsQuery__
 *
 * To run a query within a React component, call `useGetCommissionsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionsMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionsMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCommissionsMetricsQuery,
    GetCommissionsMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommissionsMetricsQuery,
    GetCommissionsMetricsQueryVariables
  >(GetCommissionsMetricsDocument, options);
}
export function useGetCommissionsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommissionsMetricsQuery,
    GetCommissionsMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommissionsMetricsQuery,
    GetCommissionsMetricsQueryVariables
  >(GetCommissionsMetricsDocument, options);
}
export type GetCommissionsMetricsQueryHookResult = ReturnType<
  typeof useGetCommissionsMetricsQuery
>;
export type GetCommissionsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCommissionsMetricsLazyQuery
>;
export type GetCommissionsMetricsQueryResult = Apollo.QueryResult<
  GetCommissionsMetricsQuery,
  GetCommissionsMetricsQueryVariables
>;
export const GetCommissionsDocument = gql`
  query GetCommissions(
    $from: String
    $to: String
    $payedOut: Boolean
    $limit: Int!
    $offset: Int!
    $userNumber: Int
  ) {
    commissions(
      from: $from
      to: $to
      payedOut: $payedOut
      limit: $limit
      offset: $offset
      userNumber: $userNumber
    ) {
      commissions {
        ...CommissionResponseExtra
      }
      totalPageCount
    }
  }
  ${CommissionResponseExtraFragmentDoc}
`;

/**
 * __useGetCommissionsQuery__
 *
 * To run a query within a React component, call `useGetCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      payedOut: // value for 'payedOut'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userNumber: // value for 'userNumber'
 *   },
 * });
 */
export function useGetCommissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommissionsQuery,
    GetCommissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommissionsQuery, GetCommissionsQueryVariables>(
    GetCommissionsDocument,
    options,
  );
}
export function useGetCommissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommissionsQuery,
    GetCommissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCommissionsQuery, GetCommissionsQueryVariables>(
    GetCommissionsDocument,
    options,
  );
}
export type GetCommissionsQueryHookResult = ReturnType<
  typeof useGetCommissionsQuery
>;
export type GetCommissionsLazyQueryHookResult = ReturnType<
  typeof useGetCommissionsLazyQuery
>;
export type GetCommissionsQueryResult = Apollo.QueryResult<
  GetCommissionsQuery,
  GetCommissionsQueryVariables
>;
export const GetForgottenPasswordTokenDocument = gql`
  query GetForgottenPasswordToken($id: String!) {
    forgottenPassword(id: $id) {
      status
    }
  }
`;

/**
 * __useGetForgottenPasswordTokenQuery__
 *
 * To run a query within a React component, call `useGetForgottenPasswordTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForgottenPasswordTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForgottenPasswordTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForgottenPasswordTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetForgottenPasswordTokenQuery,
    GetForgottenPasswordTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetForgottenPasswordTokenQuery,
    GetForgottenPasswordTokenQueryVariables
  >(GetForgottenPasswordTokenDocument, options);
}
export function useGetForgottenPasswordTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetForgottenPasswordTokenQuery,
    GetForgottenPasswordTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetForgottenPasswordTokenQuery,
    GetForgottenPasswordTokenQueryVariables
  >(GetForgottenPasswordTokenDocument, options);
}
export type GetForgottenPasswordTokenQueryHookResult = ReturnType<
  typeof useGetForgottenPasswordTokenQuery
>;
export type GetForgottenPasswordTokenLazyQueryHookResult = ReturnType<
  typeof useGetForgottenPasswordTokenLazyQuery
>;
export type GetForgottenPasswordTokenQueryResult = Apollo.QueryResult<
  GetForgottenPasswordTokenQuery,
  GetForgottenPasswordTokenQueryVariables
>;
export const GetGlobalPayoutsHistoryDocument = gql`
  query getGlobalPayoutsHistory {
    globalPayoutsHistory {
      ...PayoutsOverview
    }
  }
  ${PayoutsOverviewFragmentDoc}
`;

/**
 * __useGetGlobalPayoutsHistoryQuery__
 *
 * To run a query within a React component, call `useGetGlobalPayoutsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalPayoutsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalPayoutsHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalPayoutsHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGlobalPayoutsHistoryQuery,
    GetGlobalPayoutsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGlobalPayoutsHistoryQuery,
    GetGlobalPayoutsHistoryQueryVariables
  >(GetGlobalPayoutsHistoryDocument, options);
}
export function useGetGlobalPayoutsHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGlobalPayoutsHistoryQuery,
    GetGlobalPayoutsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGlobalPayoutsHistoryQuery,
    GetGlobalPayoutsHistoryQueryVariables
  >(GetGlobalPayoutsHistoryDocument, options);
}
export type GetGlobalPayoutsHistoryQueryHookResult = ReturnType<
  typeof useGetGlobalPayoutsHistoryQuery
>;
export type GetGlobalPayoutsHistoryLazyQueryHookResult = ReturnType<
  typeof useGetGlobalPayoutsHistoryLazyQuery
>;
export type GetGlobalPayoutsHistoryQueryResult = Apollo.QueryResult<
  GetGlobalPayoutsHistoryQuery,
  GetGlobalPayoutsHistoryQueryVariables
>;
export const GetOrderStatusDocument = gql`
  query GetOrderStatus($orderId: String!) {
    orderStatus(orderId: $orderId) {
      id
      user {
        ...User
      }
      email
      amount
      currency
      refCode
      couponCode
      orderNumber
      paymentId
      pvAmount
      status
      commissionLevel
      createdAt
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useGetOrderStatusQuery__
 *
 * To run a query within a React component, call `useGetOrderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatusQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrderStatusQuery,
    GetOrderStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderStatusQuery, GetOrderStatusQueryVariables>(
    GetOrderStatusDocument,
    options,
  );
}
export function useGetOrderStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrderStatusQuery,
    GetOrderStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderStatusQuery, GetOrderStatusQueryVariables>(
    GetOrderStatusDocument,
    options,
  );
}
export type GetOrderStatusQueryHookResult = ReturnType<
  typeof useGetOrderStatusQuery
>;
export type GetOrderStatusLazyQueryHookResult = ReturnType<
  typeof useGetOrderStatusLazyQuery
>;
export type GetOrderStatusQueryResult = Apollo.QueryResult<
  GetOrderStatusQuery,
  GetOrderStatusQueryVariables
>;
export const GetNextPayoutDetailDocument = gql`
  query getNextPayoutDetail($payoutId: String) {
    nextPayoutDetail(payoutId: $payoutId) {
      ...PayoutDetail
    }
  }
  ${PayoutDetailFragmentDoc}
`;

/**
 * __useGetNextPayoutDetailQuery__
 *
 * To run a query within a React component, call `useGetNextPayoutDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextPayoutDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextPayoutDetailQuery({
 *   variables: {
 *      payoutId: // value for 'payoutId'
 *   },
 * });
 */
export function useGetNextPayoutDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNextPayoutDetailQuery,
    GetNextPayoutDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNextPayoutDetailQuery,
    GetNextPayoutDetailQueryVariables
  >(GetNextPayoutDetailDocument, options);
}
export function useGetNextPayoutDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNextPayoutDetailQuery,
    GetNextPayoutDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNextPayoutDetailQuery,
    GetNextPayoutDetailQueryVariables
  >(GetNextPayoutDetailDocument, options);
}
export type GetNextPayoutDetailQueryHookResult = ReturnType<
  typeof useGetNextPayoutDetailQuery
>;
export type GetNextPayoutDetailLazyQueryHookResult = ReturnType<
  typeof useGetNextPayoutDetailLazyQuery
>;
export type GetNextPayoutDetailQueryResult = Apollo.QueryResult<
  GetNextPayoutDetailQuery,
  GetNextPayoutDetailQueryVariables
>;
export const GetNextPayoutsDocument = gql`
  query getNextPayouts($limit: Int!, $offset: Int!) {
    nextPayouts(limit: $limit, offset: $offset) {
      totalPageCount
      payouts {
        ...PayoutDTO
      }
    }
  }
  ${PayoutDtoFragmentDoc}
`;

/**
 * __useGetNextPayoutsQuery__
 *
 * To run a query within a React component, call `useGetNextPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextPayoutsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetNextPayoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNextPayoutsQuery,
    GetNextPayoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNextPayoutsQuery, GetNextPayoutsQueryVariables>(
    GetNextPayoutsDocument,
    options,
  );
}
export function useGetNextPayoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNextPayoutsQuery,
    GetNextPayoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNextPayoutsQuery, GetNextPayoutsQueryVariables>(
    GetNextPayoutsDocument,
    options,
  );
}
export type GetNextPayoutsQueryHookResult = ReturnType<
  typeof useGetNextPayoutsQuery
>;
export type GetNextPayoutsLazyQueryHookResult = ReturnType<
  typeof useGetNextPayoutsLazyQuery
>;
export type GetNextPayoutsQueryResult = Apollo.QueryResult<
  GetNextPayoutsQuery,
  GetNextPayoutsQueryVariables
>;
export const GetOrderDetailsDocument = gql`
  query GetOrderDetails($orderId: String) {
    orderDetails(orderId: $orderId) {
      id
      email
      amount
      currency
      refCode
      couponCode
      orderNumber
      createdAt
      member {
        ...MemberExtra
      }
      commissions {
        ...CommissionResponseExtra
      }
    }
  }
  ${MemberExtraFragmentDoc}
  ${CommissionResponseExtraFragmentDoc}
`;

/**
 * __useGetOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDetailsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrderDetailsQuery,
    GetOrderDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(
    GetOrderDetailsDocument,
    options,
  );
}
export function useGetOrderDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrderDetailsQuery,
    GetOrderDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrderDetailsQuery,
    GetOrderDetailsQueryVariables
  >(GetOrderDetailsDocument, options);
}
export type GetOrderDetailsQueryHookResult = ReturnType<
  typeof useGetOrderDetailsQuery
>;
export type GetOrderDetailsLazyQueryHookResult = ReturnType<
  typeof useGetOrderDetailsLazyQuery
>;
export type GetOrderDetailsQueryResult = Apollo.QueryResult<
  GetOrderDetailsQuery,
  GetOrderDetailsQueryVariables
>;
export const GetPaymentMethodsDocument = gql`
  query GetPaymentMethods {
    paymentMethods {
      ...PaymentMethodDetails
    }
  }
  ${PaymentMethodDetailsFragmentDoc}
`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPaymentMethodsQuery,
    GetPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPaymentMethodsQuery,
    GetPaymentMethodsQueryVariables
  >(GetPaymentMethodsDocument, options);
}
export function useGetPaymentMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaymentMethodsQuery,
    GetPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPaymentMethodsQuery,
    GetPaymentMethodsQueryVariables
  >(GetPaymentMethodsDocument, options);
}
export type GetPaymentMethodsQueryHookResult = ReturnType<
  typeof useGetPaymentMethodsQuery
>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentMethodsLazyQuery
>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<
  GetPaymentMethodsQuery,
  GetPaymentMethodsQueryVariables
>;
export const GetPayoutsHistoryDocument = gql`
  query GetPayoutsHistory {
    payoutsHistory {
      ...Payout
    }
  }
  ${PayoutFragmentDoc}
`;

/**
 * __useGetPayoutsHistoryQuery__
 *
 * To run a query within a React component, call `useGetPayoutsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutsHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutsHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutsHistoryQuery,
    GetPayoutsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPayoutsHistoryQuery,
    GetPayoutsHistoryQueryVariables
  >(GetPayoutsHistoryDocument, options);
}
export function useGetPayoutsHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutsHistoryQuery,
    GetPayoutsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPayoutsHistoryQuery,
    GetPayoutsHistoryQueryVariables
  >(GetPayoutsHistoryDocument, options);
}
export type GetPayoutsHistoryQueryHookResult = ReturnType<
  typeof useGetPayoutsHistoryQuery
>;
export type GetPayoutsHistoryLazyQueryHookResult = ReturnType<
  typeof useGetPayoutsHistoryLazyQuery
>;
export type GetPayoutsHistoryQueryResult = Apollo.QueryResult<
  GetPayoutsHistoryQuery,
  GetPayoutsHistoryQueryVariables
>;
export const GetSubaffiliatesDocument = gql`
  query GetSubaffiliates($userId: String) {
    subAffiliates(userId: $userId) {
      members {
        ...MemberExtra
      }
    }
  }
  ${MemberExtraFragmentDoc}
`;

/**
 * __useGetSubaffiliatesQuery__
 *
 * To run a query within a React component, call `useGetSubaffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubaffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubaffiliatesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSubaffiliatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubaffiliatesQuery,
    GetSubaffiliatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubaffiliatesQuery, GetSubaffiliatesQueryVariables>(
    GetSubaffiliatesDocument,
    options,
  );
}
export function useGetSubaffiliatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubaffiliatesQuery,
    GetSubaffiliatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubaffiliatesQuery,
    GetSubaffiliatesQueryVariables
  >(GetSubaffiliatesDocument, options);
}
export type GetSubaffiliatesQueryHookResult = ReturnType<
  typeof useGetSubaffiliatesQuery
>;
export type GetSubaffiliatesLazyQueryHookResult = ReturnType<
  typeof useGetSubaffiliatesLazyQuery
>;
export type GetSubaffiliatesQueryResult = Apollo.QueryResult<
  GetSubaffiliatesQuery,
  GetSubaffiliatesQueryVariables
>;
export const GetUserByEmailDocument = gql`
  query GetUserByEmail($email: String) {
    userByEmail(email: $email) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(
    GetUserByEmailDocument,
    options,
  );
}
export function useGetUserByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(
    GetUserByEmailDocument,
    options,
  );
}
export type GetUserByEmailQueryHookResult = ReturnType<
  typeof useGetUserByEmailQuery
>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<
  typeof useGetUserByEmailLazyQuery
>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<
  GetUserByEmailQuery,
  GetUserByEmailQueryVariables
>;
export const GetUserMetricsDocument = gql`
  query GetUserMetrics {
    userMetrics {
      ...UserMetrics
    }
  }
  ${UserMetricsFragmentDoc}
`;

/**
 * __useGetUserMetricsQuery__
 *
 * To run a query within a React component, call `useGetUserMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserMetricsQuery,
    GetUserMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserMetricsQuery, GetUserMetricsQueryVariables>(
    GetUserMetricsDocument,
    options,
  );
}
export function useGetUserMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserMetricsQuery,
    GetUserMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserMetricsQuery, GetUserMetricsQueryVariables>(
    GetUserMetricsDocument,
    options,
  );
}
export type GetUserMetricsQueryHookResult = ReturnType<
  typeof useGetUserMetricsQuery
>;
export type GetUserMetricsLazyQueryHookResult = ReturnType<
  typeof useGetUserMetricsLazyQuery
>;
export type GetUserMetricsQueryResult = Apollo.QueryResult<
  GetUserMetricsQuery,
  GetUserMetricsQueryVariables
>;
export const GetUserDocument = gql`
  query GetUser($searchString: String) {
    user(searchString: $searchString) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserQuery,
    GetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const GetViewerDocument = gql`
  query GetViewer {
    me {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViewerQuery,
    GetViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(
    GetViewerDocument,
    options,
  );
}
export function useGetViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViewerQuery,
    GetViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(
    GetViewerDocument,
    options,
  );
}
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<
  typeof useGetViewerLazyQuery
>;
export type GetViewerQueryResult = Apollo.QueryResult<
  GetViewerQuery,
  GetViewerQueryVariables
>;
export const RecalculateAffiliateOrderDocument = gql`
  query RecalculateAffiliateOrder(
    $accountSize: Int
    $addonTypesOnOrder: [AddonType]
    $couponCode: String
    $stepsType: StepsType
  ) {
    recalculateAffiliateOrder(
      accountSize: $accountSize
      addonTypesOnOrder: $addonTypesOnOrder
      couponCode: $couponCode
      stepsType: $stepsType
    )
  }
`;

/**
 * __useRecalculateAffiliateOrderQuery__
 *
 * To run a query within a React component, call `useRecalculateAffiliateOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecalculateAffiliateOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecalculateAffiliateOrderQuery({
 *   variables: {
 *      accountSize: // value for 'accountSize'
 *      addonTypesOnOrder: // value for 'addonTypesOnOrder'
 *      couponCode: // value for 'couponCode'
 *      stepsType: // value for 'stepsType'
 *   },
 * });
 */
export function useRecalculateAffiliateOrderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecalculateAffiliateOrderQuery,
    RecalculateAffiliateOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecalculateAffiliateOrderQuery,
    RecalculateAffiliateOrderQueryVariables
  >(RecalculateAffiliateOrderDocument, options);
}
export function useRecalculateAffiliateOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecalculateAffiliateOrderQuery,
    RecalculateAffiliateOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecalculateAffiliateOrderQuery,
    RecalculateAffiliateOrderQueryVariables
  >(RecalculateAffiliateOrderDocument, options);
}
export type RecalculateAffiliateOrderQueryHookResult = ReturnType<
  typeof useRecalculateAffiliateOrderQuery
>;
export type RecalculateAffiliateOrderLazyQueryHookResult = ReturnType<
  typeof useRecalculateAffiliateOrderLazyQuery
>;
export type RecalculateAffiliateOrderQueryResult = Apollo.QueryResult<
  RecalculateAffiliateOrderQuery,
  RecalculateAffiliateOrderQueryVariables
>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
};
export default result;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export enum AddonType {
  IncreasedLeverage = 'INCREASED_LEVERAGE',
  IncreasedProfitSplit = 'INCREASED_PROFIT_SPLIT',
  WeeklyPayouts = 'WEEKLY_PAYOUTS',
}

export type AffiliateOrderInput = {
  accountSize: Scalars['Int']['input'];
  addons?: InputMaybe<Array<InputMaybe<AddonType>>>;
  countryCode: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  paymentGateway?: InputMaybe<PaymentGateway>;
  paymentRequired: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  stepsType?: InputMaybe<StepsType>;
};

export enum CommissionStatus {
  Locked = 'LOCKED',
  Paid = 'PAID',
  PayoutRequested = 'PAYOUT_REQUESTED',
  Unlocked = 'UNLOCKED',
}

export type CouponCodeInput = {
  couponCode: Scalars['String']['input'];
};

export type CouponConfig = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
};

export enum NetworkRole {
  Affiliate = 'AFFILIATE',
  Mlm = 'MLM',
}

export type OrderInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  maxCommissionLevel?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderType: OrderType;
  paymentGateway?: InputMaybe<PaymentGateway>;
  refCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderStatus {
  Paid = 'PAID',
  Placed = 'PLACED',
}

export enum OrderType {
  AffiliateOrder = 'AFFILIATE_ORDER',
  LevelPackage = 'LEVEL_PACKAGE',
  Order = 'ORDER',
}

export enum PaymentGateway {
  Confirmo = 'CONFIRMO',
  Stripe = 'STRIPE',
}

export type PaymentMethodInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<WithdrawalPaymentMethod>;
  paymentMethodMetadata?: InputMaybe<Scalars['String']['input']>;
  targetAddress?: InputMaybe<Scalars['String']['input']>;
};

export enum PayoutStatus {
  Declined = 'DECLINED',
  Paid = 'PAID',
  Requested = 'REQUESTED',
}

export type RefCodeInput = {
  refCode?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationUserInput = {
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  networkRole?: InputMaybe<NetworkRole>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredLocale?: InputMaybe<Scalars['String']['input']>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialLoginProvider {
  Google = 'GOOGLE',
}

export enum StepsType {
  OneStep = 'ONE_STEP',
  ThreeSteps = 'THREE_STEPS',
  TwoSteps = 'TWO_STEPS',
}

export enum ValidationCodeResponseStatus {
  AlreadyVerified = 'ALREADY_VERIFIED',
  Error = 'ERROR',
  Sent = 'SENT',
}

export enum WithdrawalPaymentMethod {
  DirectCrypto = 'DIRECT_CRYPTO',
  Rise = 'RISE',
}
